import { baseApi } from "common/redux/core/api.base";
import { saveAsFile } from "common/utils/file";
import { DownloadService } from "../../services/download.service";
import { documentsConfig } from "../../config/document.config";
import { downloadDocRequest } from "../../models/requirements.model";

const downloadDocumentApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    downloadDocument: build.query<any, any>({
      queryFn: async (request: downloadDocRequest) => {
        const config = documentsConfig.downloadDocuments(
          request.documentGuid,
          request.downloadType
        );
        const response = await DownloadService.invokeDownload(config);
        saveAsFile(response.value, `${request.documentName}.xlsx`);
        return new Promise((resolve, reject) => {
          resolve(response as any);
        });
      }
    })
  })
});

export const { useLazyDownloadDocumentQuery } = downloadDocumentApi;
